// components/PrivateRoutesContainer.tsx
import { Route } from "react-router-dom";
import ProtectedRoute from "../../core/common/autorisations/protectedRoute";
import ProtectedRouteWithPermission from "../../core/common/autorisations/protectedRouteWithPermission";
import Feature from "../feature";
import {
  privateRoutesParent,
  privateRoutesStudent,
  privateRoutesUser,
  privateRoutesTeacher,
} from "./router.link";

export const getPrivateRoutes = (userType: string) => {
  const routes =
    userType === "UserProfil"
      ? privateRoutesUser
      : userType === "StudentProfil"
        ? privateRoutesStudent
        : userType === "TeacherProfil"
          ? privateRoutesTeacher
          : userType === "ParentProfil"
            ? privateRoutesParent
            : [];

  return routes.map((route: any) => (
    <Route element={<ProtectedRoute />} key={`protected-${route.path}`}>
      <Route element={<Feature />}>
        <Route
          element={
            <ProtectedRouteWithPermission
              requiredPermissions={route.permissions}
            />
          }
        >
          <Route path={route.path} element={route.element} />
        </Route>
      </Route>
    </Route>
  ));
};
